import { Props_SnippetBenefit } from './Benefit.props'
import SnippetLink from '../Shared/Link/Link'
import { CompileMarkdown, CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetBenefit = (props: Props_SnippetBenefit) => {
    const { heading, repeatable_entry } = props

    return (
        <section className="snippet-benefit">
            <div className="snippet-benefit__container">
                {heading?.content?.value && (
                    <h2 className={`snippet-benefit__heading${!heading.visibility?.value ? ' accessible-heading' : ''}`}>
                        {CompileHeadingToSpan(heading.content.value)}
                    </h2>
                )}
                <div className="snippet-benefit__cards">
                    {repeatable_entry.map(({ icon, iconWhite, color, title, content, linkHref, linkStyle, linkTarget, linkText }, index: number) => {
                        const colorClass = color?.value ? `snippet-benefit__card--${color.value}` : ''
                        return (
                            <div key={index} className={`snippet-benefit__card ${colorClass}`}>
                                <div className="snippet-benefit__icon-container">
                                    {icon?.value && (
                                        <img
                                            className="snippet-benefit__icon snippet-benefit__icon--default"
                                            loading="lazy"
                                            height={138}
                                            width={138}
                                            src={icon.value}
                                            alt=""
                                            aria-hidden="true"
                                        />
                                    )}
                                    {iconWhite?.value && (
                                        <img
                                            className="snippet-benefit__icon snippet-benefit__icon--white"
                                            loading="lazy"
                                            height={138}
                                            width={138}
                                            src={iconWhite.value}
                                            alt=""
                                            aria-hidden="true"
                                        />
                                    )}
                                </div>
                                <div className="snippet-benefit__content-container">
                                    {title?.value && <h3 className="snippet-benefit__card-title">{CompileHeadingToSpan(title.value)}</h3>}
                                    {content?.value && <div className="snippet-benefit__card-content">{CompileMarkdown(content.value)}</div>}
                                    <SnippetLink
                                        url={linkHref?.value}
                                        className="snippet-benefit__link"
                                        linkStyles={linkStyle?.value}
                                        openInNewTab={linkTarget?.value}
                                    >
                                        {linkText?.value}
                                    </SnippetLink>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default SnippetBenefit
